import { render } from "./SearchStockItems.vue?vue&type=template&id=67e6c151&ts=true"
import script from "./SearchStockItems.vue?vue&type=script&lang=ts"
export * from "./SearchStockItems.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__